var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.3C7.19512 3.3 3.3 7.19512 3.3 12C3.3 16.8049 7.19512 20.7 12 20.7C16.8049 20.7 20.7 16.8049 20.7 12C20.7 7.19512 16.8049 3.3 12 3.3ZM1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12Z",
    fill: "#FF3440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9996 7.5C12.4967 7.5 12.8996 7.90294 12.8996 8.4V12.9C12.8996 13.3971 12.4967 13.8 11.9996 13.8C11.5026 13.8 11.0996 13.3971 11.0996 12.9V8.4C11.0996 7.90294 11.5026 7.5 11.9996 7.5Z",
    fill: "#FF3440"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9996 14.7002C12.4967 14.7002 12.8996 15.1031 12.8996 15.6002V15.6602C12.8996 16.1573 12.4967 16.5602 11.9996 16.5602C11.5026 16.5602 11.0996 16.1573 11.0996 15.6602V15.6002C11.0996 15.1031 11.5026 14.7002 11.9996 14.7002Z",
    fill: "#FF3440"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertCircle);
export default __webpack_public_path__ + "static/media/icon-alert-circle.53e3d7f156628e5cbf91fc87cba1fe10.svg";
export { ForwardRef as ReactComponent };